import React from 'react'
import PropTypes from 'prop-types'
import CreateTextField from '../../../components/CreateTextField'

const TASK_NAME_MAX_LENGTH = 200

class AddCard extends React.Component {

  onCancel = () => {
    this.props.onAddCancel()
  }

  onSave = (isBlur, taskName) => {
    const addAnotherTask = !isBlur
    this.props.onAddSave(taskName, addAnotherTask, this.props.laneId)
  }

  render() {
    return (
      <div className='card'>
        <CreateTextField
          minRows={2}
          onSave={this.onSave}
          onCancel={this.onCancel}
          maxLength={TASK_NAME_MAX_LENGTH}
          disallowCr />
      </div>
    )
  }
}

AddCard.propTypes = {
  onAddCancel: PropTypes.func.isRequired,
  onAddSave: PropTypes.func.isRequired,
  laneId: PropTypes.string.isRequired
}

export default AddCard



// WEBPACK FOOTER //
// ./src/routes/Board/components/AddCard.js